import React from 'react';
import Button from "react-bootstrap/Button";
import {useHistory} from "react-router-dom";
import {reloadOrRedirect} from '../../../utils/location-utils';

/**
 * Shortcut button for opening the schema generate wizard.
 */
export default function GenerateSchemaAction(props: { forbidden?: boolean }) {
  const history = useHistory();
  const pageUrl = '/schema/generate';
  const title = props.forbidden ? 'Generate schema is forbidden' : 'Generate schema';
  return (
    <Button onClick={() => reloadOrRedirect(history, pageUrl, pageUrl)}
            className="generate-schema-button btn btn-primary"
            disabled={props.forbidden}
            title={title}>
      Generate Schema
    </Button>
  );
}
